module.exports = __webpack_public_path__ + "static/media/bgshape.086d643a.svg";